import { parseCookie as e } from "../utils/cookie-parser.js";
var o;
const m = ((o = e()) == null ? void 0 : o.swymlang) || "en";
export {
  m as DS_LANG
};
